export default __webpack_public_path__ + "static/042-a8269076244999e601bd46f6c7533bed.png";